import React from 'react';
import banner3 from "../../assets/nerbanner/aboutbanner.jpeg";
import "./about.css";

function About() {
    return (
        <>
            <section className='about-section'>
                <div className='container'>
                    <div className='row'>                      
                        <div class="col-lg-6">
                            <div class="ttm_single_image-wrapper after-border style2 position-relative ml-20">
                                <img class="img-fluid border-12px-solid white-border" src={banner3} title="single-img-five" alt="single-img-five" />
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="spacing-1 ttm-bgcolor-white bordertop-12px-solid skincolor-border">

                                <div class="section-title clearfix">
                                    <div class="title-header">
                                        <h5 style={{ textTransform: "uppercase", color:" #ffb703" }}>About</h5>
                                        <h3>TRIPLETTE CONSULTANCY</h3>
                                        </div>
                                    <div className='underline'></div>
                                </div>

                                <h4 style={{color:"#2563eb"}}>Empowering Ambitions. Building Careers:</h4>

                                <p className='p-para'>At Triplette, we believe in the power of the right opportunity at the right time. Founded in Chennai, our company serves as a strategic link between skilled job seekers and reputable organizations in the Information Technology (IT) and Information Technology Enabled Services (ITES) sectors.</p>
                                <p className='p-para'>We work closely with Level 1 to Level 5 companies, offering our candidates access to a wide spectrum of job roles — from entry-level positions to experienced profiles. Our approach is personalized, career-focused, and built on long-standing industry relationships.</p>
                                <form className="d-flex">
                                <a href="tel:8072712418" className="btn get-button">Get Enquiry</a>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default About
